import React from "react";
import { Carousel } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaStar, FaQuoteLeft } from "react-icons/fa"; // Standard Icons
import { FcGoogle } from "react-icons/fc"; // Original Colored Google Icon
import reviewImg from "../Ecomphotos/ee.jpg";

const reviews = [
  {
    id: 1,
    name: "Krrish Vora",
    date: "Dec 20, 2022",
    rating: 5,
    comment:
      "Good service and management. The team was very responsive and ensured we had a hassle-free experience.",
  },
  {
    id: 2,
    name: "Amar Sen",
    date: "Dec 22, 2022",
    rating: 5,
    comment:
      "It was an amazing trip with Jawali Holidays. I booked Mahabaleshwar. Management, food, and service were perfect!",
  },
  {
    id: 3,
    name: "Priya Sharma",
    date: "Jan 10, 2023",
    rating: 4,
    comment:
      "Great experience! The itinerary was well planned. Hotels were decent and the driver was very polite.",
  },
];

const ClientReviews = () => {
  return (
    <section className="review-section py-5">
      <div className="container">
        <div className="row align-items-center">
          {/* Left Side: Image (Travel Vibe) */}
          <div className="col-lg-5 mb-4 mb-lg-0">
            <div className="image-container">
              <img
                src={reviewImg}
                alt="Happy Travelers"
                className="img-fluid rounded-4 shadow-lg main-img"
              />
              {/* Floating Badge on Image */}
              <div className="floating-badge">
                <span className="fw-bold h4 m-0">500+</span>
                <span className="small text-muted d-block">
                  Happy Travelers
                </span>
              </div>
            </div>
          </div>

          {/* Right Side: Reviews Content */}
          <div className="col-lg-7 ps-lg-5">
            {/* Header */}
            <h6 className="text-uppercase text-danger fw-bold ls-2">
              Testimonials
            </h6>
            <h2 className="fw-bold mb-4 display-6">
              What Our Clients Say <br /> About{" "}
              <span className="text-primary-custom">Jawali Holidays</span>
            </h2>

            {/* Google Rating Widget */}
            <div className="google-widget d-inline-flex align-items-center mb-4 shadow-sm p-3 rounded bg-white">
              <FcGoogle className="google-icon me-3" size={30} />
              <div className="widget-text text-start">
                <div className="d-flex align-items-center">
                  <span className="fw-bold me-2">Excellent</span>
                  <div className="stars text-warning">
                    {[...Array(5)].map((_, i) => (
                      <FaStar key={i} size={14} />
                    ))}
                  </div>
                </div>
                <small className="text-muted">
                  Based on <strong>50+ reviews</strong> on Google
                </small>
              </div>
            </div>

            {/* Carousel Reviews */}
            <Carousel
              indicators={false}
              controls={true}
              interval={4000}
              className="review-carousel"
            >
              {reviews.map((review) => (
                <Carousel.Item key={review.id}>
                  <div className="review-card p-4 rounded-4 bg-white shadow-sm border position-relative">
                    {/* Background Quote Icon */}
                    <FaQuoteLeft className="quote-watermark" />

                    <div className="d-flex align-items-center mb-3 position-relative z-2">
                      {/* Avatar Circle */}
                      <div className="avatar-circle me-3">
                        {review.name.charAt(0)}
                      </div>
                      <div>
                        <h5 className="fw-bold mb-0">{review.name}</h5>
                        <small className="text-muted">{review.date}</small>
                      </div>
                    </div>

                    {/* Stars */}
                    <div className="mb-3 text-warning position-relative z-2">
                      {[...Array(review.rating)].map((_, i) => (
                        <FaStar key={i} className="me-1" />
                      ))}
                    </div>

                    {/* Comment */}
                    <p className="text-secondary fst-italic position-relative z-2">
                      "{review.comment}"
                    </p>
                  </div>
                </Carousel.Item>
              ))}
            </Carousel>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientReviews;
